<template>
  <div
    @click="$emit('clickOnCta')"
    class="vadCta has-cursor-pointer">
    <div class="vadCta-avatar">
      <avatar
        :is-avatar="false"
        :force-picto="true"
        :item="{}"
        :use-picto-custom="'fal fa-comment-alt-lines'"
        class="is-xlarge has-background-dark has-text-white">
      </avatar>
    </div>
    <div class="vadCta-textes collapse-style">
      <div class="title is-5 is-margin-bottom-xxsmall hidden-style">
        <b>Une question ?</b>
      </div>
      <div class="is-size-6 hidden-style">
        <span class="has-text-dark is-underline">Contactez un responsable programme</span>
      </div>
    </div>
  </div><!-- /.vadCta -->
</template>

<script>
export default {
  name: 'CtaToPromoteur',
  components: {},
  mixins: [],
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {
  }
}
</script>

<style lang="sass">
.vadCta
  position: fixed !important
  bottom: 20px
  right: 20px
  z-index: 1000

.collapse-style
  max-height: 75px
  overflow: hidden
  max-width: 0
  opacity: 0
  padding-left: 0
  padding-right: 0
  transform-origin: left
  transition: opacity 0.5s ease, transform 0.5s ease, max-width 0.5s ease, padding-left 0.7s ease, padding-right 0.7s ease !important

.vadCta:hover .collapse-style
  max-width: 400px
  opacity: 1
  padding-left: 2.2rem
  padding-right: 2.2rem

.hidden-style
  white-space: nowrap
  overflow: hidden
</style>
